var AppDispatcher = require('../dispatcher/AppDispatcher');
var AnnouncementConstants = require('../constants/AnnouncementConstants');

// Define action methods
var AnnouncementActions = {
  // Receive inital product data
  receiveState: function (data) {
    AppDispatcher.handleAction({
      actionType: AnnouncementConstants.RECEIVE_DATA,
      data: data
    })
  },
  addAnnouncement: function (data) {
    AppDispatcher.handleAction({
      actionType: AnnouncementConstants.ADD_ANNOUNCEMENT,
      data: data
    })
  },
  editAnnouncement: function (data) {
    AppDispatcher.handleAction({
      actionType: AnnouncementConstants.EDIT_ANNOUNCEMENT,
      data: data
    })
  },
  deleteAnnouncement: function (data) {
    AppDispatcher.handleAction({
      actionType: AnnouncementConstants.DELETE_ANNOUNCEMENT,
      data: data
    })
  }
};

module.exports = AnnouncementActions;


/** WEBPACK FOOTER **
 ** ./src/actions/AnnouncementActions.js
 **/